import { render, staticRenderFns } from "./SystemItemsGroup.vue?vue&type=template&id=f5d150ec&scoped=true&"
import script from "./SystemItemsGroup.vue?vue&type=script&lang=js&"
export * from "./SystemItemsGroup.vue?vue&type=script&lang=js&"
import style0 from "./SystemItemsGroup.vue?vue&type=style&index=0&id=f5d150ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5d150ec",
  null
  
)

export default component.exports